import { ContentItem, PostItem } from "hc-entities";
import { CommunitiesService } from "../../globals/services/communities.service";
import { ContentService } from "../../globals/services/content.service";
import { EventsService } from "../../globals/services/events.service";
import { PostService } from "../../globals/services/post.service";
import { UsersService } from "../../globals/services/users.service";
import { AdminContentItem } from "../reducers/contentReducer";
import { showLoader } from "./mainActions";

export const SET_CONTENT = "SET_CONTENT";
export const SET_MSG_CONTENT = "SET_MSG_CONTENT";
export const SET_CURRENT_CONTENT = "SET_CURRENT_CONTENT";
export const FETCH_CONTENT = "FETCH_CONTENT";
export const SET_COMMUNITIES = "SET_COMMUNITIES";
export const SET_USERS_FOR_CONTENT = "SET_USERS_FOR_CONTENT";
export const SET_COURSES = "SET_COURSES";
export const SEARCH_CONTENT = "SEARCH_CONTENT";

export const addContent = (content: AdminContentItem) => {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader(true));
      const contentService = ContentService();
      await contentService.post(content);
      dispatch(showLoader(false));
    } catch (err: any) {
      dispatch(showLoader(false));
      throw err;
    }
  };
};

export const publishPost = (post: PostItem, isQuickPost?: boolean, isEdit?: boolean) => {
  return async (dispatch: any) => {
    try {
      dispatch(showLoader(true));
      if (!isQuickPost) {
        const postService = PostService();
        await postService.post(post, isEdit);
      } else {
        const postService = PostService();
        await postService.quickPost(post, isEdit);
      }
      dispatch(showLoader(false));
    } catch (err: any) {
      dispatch(showLoader(false));
      throw err;
    }
  };
};

export const getContent = () => {
  return async (dispatch: any) => {
    try {
      const contentService = ContentService();
      const content = await contentService.get();
      dispatch({ type: SET_CONTENT, value: content });
    } catch (err: any) {
      console.error(err);
    }
  };
};

export const searchContent = (term: String) => {
  return async (dispatch: any) => {
    try {
      const contentService = ContentService();
      const content = await contentService.searchContentItems(term);
      dispatch({ type: SET_CONTENT, value: content });
    } catch (err) {
      console.error(err);
    }
  }
}

export const getCommunities = () => {
  return async (dispatch: any) => {
    try {
      const subTitle = (type: string) => {
        switch (type) {
          case 'standard': {
            return ' - Community'
          }
          case 'system': {
            return ' - Course'
          }
          default: {
            return ''
          }
        }
      }

      const communitiesService = CommunitiesService();
      const res = await communitiesService.get();
      const _communities = res.map((c: any) => ({
        label: c.name + subTitle(c.communityType),
        value: c._id,
      }));
      dispatch({ type: SET_COMMUNITIES, value: _communities });
    } catch (err: any) {
      console.error(err);
    }
  };
};

export const getCourses = () => {
  return async (dispatch: any) => {
    try {
      const eventsService = EventsService();
      const _courses = await eventsService.getCourses();
      dispatch({ type: SET_COURSES, value: _courses });
    } catch (err: any) {
      console.error(err);
    }
  };
};

export const getUsers = () => {
  return async (dispatch: any) => {
    try {
      const usersService = UsersService();
      const res = await usersService.getAll();
      const _users = res.map((u: any) => ({
        label: u.firstName + " " + u.lastName,
        value: u._id,
      }));
      dispatch({ type: SET_USERS_FOR_CONTENT, value: _users });
    } catch (err: any) {
      console.error(err);
    }
  };
};

export const setCurrentContent = (content: ContentItem) => {
  return { type: SET_CURRENT_CONTENT, value: content };
};

export const msgToSend = (msg: string) => {
  return { type: SET_MSG_CONTENT, value: msg };
}
